// Numeric length + unit select for relative and anniversary date conditions.
import React from "react";

import { InputNumeric, SingleSelectInput } from "@performyard/py-components";

import type { DateSubType } from "./types";

import { ANNIVERSARY_DATE_UNITS, RELATIVE_DATE_UNITS } from "./constants";

type RelativeDateInputProps = {
	length: number;
	unit: string;
	dateSubType: DateSubType;
	onLengthChange: (length: number) => void;
	onUnitChange: (unit: string) => void;
	index?: number;
};

export const RelativeDateInput = ({
	length,
	unit,
	dateSubType,
	onLengthChange,
	onUnitChange,
	index = 0,
}: RelativeDateInputProps) => {
	const unitOptions = dateSubType === "anniversary" ? ANNIVERSARY_DATE_UNITS : RELATIVE_DATE_UNITS;

	return (
		<div className="flex flex-col gap-2">
			<InputNumeric value={length} onChange={(val) => onLengthChange(val)} placeholder="Enter numeric value" />
			<SingleSelectInput
				options={unitOptions}
				value={unit}
				onChange={(val) => {
					if (val) onUnitChange(val);
				}}
				placeholder="Select duration"
				id={`relative-date-unit-${index}`}
			/>
		</div>
	);
};
